module.exports = __webpack_public_path__ + "media/images/giftcard/home-presentation-005f674ffcf24056d825b7a78962e107.jpg";